import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';


export default function CustomDialog({ open, handleClose, content, actions }) {


    return(
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    padding: 0,
                    borderRadius: 2,
                    boxShadow: 24,
                },
            }}
        >
            
            <DialogContent  sx={{padding: '0 !important'}}>
                {content}
            </DialogContent>
        </Dialog>
    )
}